import { render, staticRenderFns } from "./immigration_history_citizenships.vue?vue&type=template&id=5a55cee4&"
import script from "./immigration_history_citizenships.vue?vue&type=script&lang=js&"
export * from "./immigration_history_citizenships.vue?vue&type=script&lang=js&"
import style0 from "./immigration_history_citizenships.vue?vue&type=style&index=0&id=5a55cee4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports